import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import store from './../../redux/store';
import { getDbConfigData } from './../../helpers/component-helper-methods';
import ModalBox from './../../sharedcomponents/modal-box/ModalBox';

// Function to get the definition based on status
export const getStatusDefinition = (status) => {
  let dbConfigData = store.getState()?.dbConfig;
  const match = dbConfigData?.entitlementStatusDefinition?.find(
    (item) => item.Status === status,
  );
  return match ? match.Definition : status;
};

const StatusDefinitionHeader = (props) => {
  const {
    displayName,
    enableMenu,
    showColumnMenu,
    column,
    progressSort,
    menuIcon,
    loading,
  } = props;

  const [sortState, setSortState] = useState(column.getSort()); // 'asc' | 'desc' | null
  const [showModal, setShowModal] = useState(false);
  const [entitlementStatusDefinition, setEntitlementStatusDefinitionn] =
    useState([]);

  const dispatch = useDispatch();

  // Listen for sort changes
  useEffect(() => {
    const listener = () => {
      setSortState(column.getSort());
    };
    column.addEventListener('sortChanged', listener);
    return () => column.removeEventListener('sortChanged', listener);
  }, [column]);

  const getEntitlementStatusDefinitionData = async () => {
    try {
      let storeDBConfig = await getDbConfigData(dispatch);
      if (storeDBConfig?.entitlementStatusDefinition?.length > 0) {
        setEntitlementStatusDefinitionn(
          storeDBConfig.entitlementStatusDefinition,
        );
      }
    } catch (err) {}
  };

  useEffect(() => {
    getEntitlementStatusDefinitionData();
  }, []);

  const handleSort = useCallback(
    (e) => {
      e.stopPropagation();
      progressSort();
    },
    [progressSort],
  );

  const onLinkClick = (e) => {
    e.stopPropagation();
    setShowModal(true); // Open the modal
  };

  const onMenuClick = (e) => {
    e.stopPropagation();
    showColumnMenu(e.currentTarget);
  };

  const renderSortIcon = () => {
    if (sortState === 'asc') {
      return <span className="ag-icon ag-icon-asc" />;
    } else if (sortState === 'desc') {
      return <span className="ag-icon ag-icon-desc" />;
    } else {
      return null;
    }
  };

  const handleCloseModal = () => {
    setShowModal(false); // Close the modal
  };

  return (
    <>
      <div
        className="ag-header-cell-label"
        role="presentation"
        onClick={handleSort}
        style={{ display: 'flex', alignItems: 'center' }}
      >
        <div
          className="ag-header-cell-text"
          style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
        >
          {displayName} -{' '}
          <span
            onClick={onLinkClick}
            style={{
              marginLeft: 4,
              marginRight: 5,
              color: 'blue',
              cursor: 'pointer',
            }}
          >
            Status Definition
          </span>
          {renderSortIcon()}
        </div>
      </div>
      {enableMenu && (
        <span
          className="ag-header-icon ag-header-cell-menu-button"
          role="presentation"
          onClick={onMenuClick}
        >
          {menuIcon || <span className="ag-icon ag-icon-menu" />}
        </span>
      )}

      {/* Modal */}
      <ModalBox
        backdrop="static"
        show={showModal}
        size="lg"
        // contentClassName="modal-height-fix"
        handleClose={handleCloseModal}
        showLoader={loading}
        modalTitle="Entitlement Status Definitions"
      >
        <div className="">
          {Array.isArray(entitlementStatusDefinition) &&
            entitlementStatusDefinition.map((data, index) => (
              <div key={index} className="mb-3">
                <span className="fw-bolder">{data.Status} </span> -{' '}
                {data.Definition}
              </div>
            ))}
        </div>
      </ModalBox>
    </>
  );
};

export default StatusDefinitionHeader;
